import {Component} from 'react';
import PropTypes from 'prop-types';
import {debounce} from 'throttle-debounce';
import lightBlue from '@material-ui/core/colors/lightBlue';
import ProcessOutcomeLobby from 'ProcessOutcomeLobby/Presentation/ProcessOutcomeLobby';
import {findProcessOutcomeBySbsId} from 'ProcessOutcomeLobby/service/ProcessOutcomeService';

const lightBlueA100 = lightBlue.A100;
const mapProcessOutcome = (processOutcome, selectedProcessOutcome) => ({
  id: processOutcome.id,
  outcome: processOutcome.outcome,
  outcomeSbsId: processOutcome.outcomeSbs ? processOutcome.outcomeSbs.id : '',
  outcomeSbsTitle: processOutcome.outcomeSbs
    ? processOutcome.outcomeSbs.title
    : 'None',
  style: {
    backgroundColor:
      processOutcome.id === selectedProcessOutcome.id ? lightBlueA100 : null,
  },
});
const filterProcessOutcomeByFilterQuery = (processOutcome, filterQuery) => {
  if (!filterQuery) return true;
  const processOutcomeValues = [
    processOutcome.outcome,
    processOutcome.outcomeSbsTitle,
  ];

  return processOutcomeValues.some((value) =>
    value
      .toString()
      .toUpperCase()
      .includes(filterQuery.toString().toUpperCase()),
  );
};
const sortProcessOutcome = (a, b, query) => {
  if (!(query.processOutcomeOrder && query.processOutcomeColumn)) {
    return a.outcome
      .toString()
      .localeCompare(b.outcome.toString(), 'AU', {numeric: true});
  }

  return (
    (query.processOutcomeOrder === 'asc' ? 1 : -1) *
    a[query.processOutcomeColumn]
      .toString()
      .localeCompare(b[query.processOutcomeColumn].toString(), 'AU', {
        numeric: true,
      })
  );
};
const getProcessOutcomes = (processOutcomes, selectedProcessOutcome, query) =>
  processOutcomes
    .map((item) => mapProcessOutcome(item, selectedProcessOutcome))
    .filter((item) =>
      filterProcessOutcomeByFilterQuery(item, query.processOutcomeFilter),
    )
    .sort((a, b) => sortProcessOutcome(a, b, query));

class ProcessOutcomeLobbyContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProcessOutcome: {},
      processOutcomes: [],
    };
  }

  handleChangeProcessOutcomesFilterQuery = debounce(
    500,
    (event, processOutcomeFilter) => {
      const {
        context: {router},
        props: {
          location: {query, pathname},
        },
      } = this;

      router.replace({
        pathname,
        query: {
          ...query,
          processOutcomeFilter,
        },
      });
    },
  );

  componentDidMount() {
    const {
      props: {
        sbs: {id: sbsId},
      },
    } = this;

    this.handleRetrieveProcessOutcomes(sbsId);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({sbs: {id}}) {
    const {
      props: {
        sbs: {id: prevId},
      },
      handleRetrieveProcessOutcomes,
    } = this;

    if (id !== prevId) {
      handleRetrieveProcessOutcomes(id);
    }
  }

  handleRetrieveProcessOutcomes = async (sbsId) => {
    const processOutcomes = await findProcessOutcomeBySbsId(sbsId);

    this.setState({processOutcomes});
  };

  handleProcessOutcomesTableChangeSelectedRow = (selectedProcessOutcome) => {
    this.setState({selectedProcessOutcome});
  };

  handleProcessOutcomesTableChangeSortOrder = (column, order) => {
    const {
      context: {router},
      props: {
        location: {query, pathname},
      },
    } = this;

    router.replace({
      pathname,
      query: {
        ...query,
        processOutcomeColumn: column,
        processOutcomeOrder: order,
      },
    });
  };

  render() {
    const {
      state: {processOutcomes, selectedProcessOutcome},
      props: {
        location,
        location: {query},
        sbs,
      },
      handleProcessOutcomesTableChangeSelectedRow,
      handleProcessOutcomesTableChangeSortOrder,
      handleChangeProcessOutcomesFilterQuery,
    } = this;
    const filteredProcessOutcomes = getProcessOutcomes(
      processOutcomes || [],
      selectedProcessOutcome,
      query,
    );

    return (
      <ProcessOutcomeLobby
        location={location}
        sbs={sbs}
        transformedProcessOutcomes={filteredProcessOutcomes}
        selectedProcessOutcome={selectedProcessOutcome}
        onProcessOutcomesTableChangeSelectedRow={
          handleProcessOutcomesTableChangeSelectedRow
        }
        onProcessOutcomesTableChangeSortOrder={
          handleProcessOutcomesTableChangeSortOrder
        }
        onChangeProcessOutcomesFilterQuery={
          handleChangeProcessOutcomesFilterQuery
        }
      />
    );
  }
}

ProcessOutcomeLobbyContainer.propTypes = {
  location: PropTypes.object.isRequired,
  sbs: PropTypes.object.isRequired,
};

ProcessOutcomeLobbyContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default ProcessOutcomeLobbyContainer;
